import WatermarkPanel from './WatermarkPanelContainer';

export default WatermarkPanel;